import React, { useState } from 'react';
import './DocumentsSection.css';

const DocumentsSection: React.FC = () => {
  const [openBlock, setOpenBlock] = useState<number | null>(null);

  const toggleBlock = (blockNumber: number) => {
    setOpenBlock(openBlock === blockNumber ? null : blockNumber);
  };

  return (
    <section className="documents-section" id="documents">
      <div className="documents-content">
        <div className="expandable-blocks">
          <div className={`expandable-block ${openBlock === 1 ? 'open' : ''}`}>
            <div className="block-header">
              <h3>ПОЛОЖЕНИЕ</h3>
              <button 
                className="expand-button"
                onClick={() => toggleBlock(1)}
              >
                {openBlock === 1 ? 'свернуть' : 'подробнее'}
              </button>
            </div>
            <div className="block-content">
              <div className="document-download">
                <p>Ознакомьтесь с полным положением о Всероссийском хакатоне по нанотехнологиям:</p>
                <a 
                  href="/static/ПОЛОЖЕНИЕ О ВСЕРОССИИЙСКОМ ХАКАТОНЕ.pdf" 
                  download="Положение о Всероссийском хакатоне.pdf"
                  className="download-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  📄 Скачать положение (PDF)
                </a>
              </div>
            </div>
          </div>

          <div className={`expandable-block ${openBlock === 2 ? 'open' : ''}`}>
            <div className="block-header">
              <h3>СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ</h3>
              <button 
                className="expand-button"
                onClick={() => toggleBlock(2)}
              >
                {openBlock === 2 ? 'свернуть' : 'подробнее'}
              </button>
            </div>
            <div className="block-content">
              <div className="consent-text">
                <h4>СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ</h4>
                
                <p>
                  Я, участник Всероссийского хакатона по нанотехнологиям (далее — «Хакатон»), 
                  в соответствии с требованиями Федерального закона от 27.07.2006 № 152-ФЗ 
                  «О персональных данных», даю свое согласие АНО детский технопарк 
                  «Красноярский Кванториум» (далее — «Организатор») на обработку моих персональных данных.
                </p>

                <h5>1. Персональные данные, на обработку которых дается согласие:</h5>
                <ul>
                  <li>фамилия, имя, отчество;</li>
                  <li>дата рождения;</li>
                  <li>контактная информация (номер телефона, адрес электронной почты);</li>
                  <li>образовательная организация, курс/класс обучения;</li>
                  <li>фотографии и видеоматериалы с участием субъекта персональных данных;</li>
                  <li>иные данные, предоставленные при регистрации на Хакатон.</li>
                </ul>

                <h5>2. Цели обработки персональных данных:</h5>
                <ul>
                  <li>организация и проведение Хакатона;</li>
                  <li>обеспечение связи с участниками;</li>
                  <li>подведение итогов и награждение победителей;</li>
                  <li>информационное сопровождение мероприятия;</li>
                  <li>создание фото- и видеоотчетов о проведении Хакатона;</li>
                  <li>размещение информации о мероприятии в СМИ и социальных сетях.</li>
                </ul>

                <h5>3. Способы обработки персональных данных:</h5>
                <p>
                  Организатор осуществляет обработку персональных данных как с использованием 
                  средств автоматизации, так и без их использования (смешанная обработка).
                </p>

                <h5>4. Срок действия согласия:</h5>
                <p>
                  Настоящее согласие действует с момента его предоставления до момента 
                  отзыва субъектом персональных данных.
                </p>

                <h5>5. Права субъекта персональных данных:</h5>
                <p>
                  Субъект персональных данных имеет право на отзыв настоящего согласия, 
                  а также на получение информации, касающейся обработки его персональных данных.
                </p>

                <p className="consent-note">
                  <strong>Внимание:</strong> Участие в Хакатоне возможно только при наличии 
                  данного согласия. Для участников младше 18 лет требуется согласие 
                  родителей или законных представителей.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DocumentsSection; 